// @file Surface permissions store
import { GroupByTypes } from '@padlet/arvo'
import window from 'bits/global'
import { defineStore, storeToRefs } from 'pinia'
import { useSurfaceFilterStore } from 'pinia/surface_filter'
import { useSurfacePostSearchStore } from 'pinia/surface_post_search'
import { useSurfaceWishArrangementStore } from 'pinia/surface_wish_arrangement'
import { computed } from 'vue'

export const useSurfacePermissionsStore = defineStore('surfacePermissions', () => {
  const surfaceVuexStore = window.app?.$store // For gradual conversion to pinia

  const { wishGroupBy, isNotSectionedAndNonmanualSorted } = storeToRefs(useSurfaceWishArrangementStore())
  const { searchTerm } = storeToRefs(useSurfacePostSearchStore())
  const { hasSelectedFilters } = storeToRefs(useSurfaceFilterStore())

  const canIWrite = computed<boolean>(() => surfaceVuexStore?.getters.canIWrite)

  const canIModerate = computed<boolean>(() => surfaceVuexStore?.getters.canIModerate)
  const isPostable = computed<boolean>(() => surfaceVuexStore?.getters.isPostable)
  const canIDragPosts = computed(() => {
    if (
      !canIWrite.value ||
      searchTerm.value !== '' ||
      hasSelectedFilters.value ||
      isNotSectionedAndNonmanualSorted.value
    )
      return false
    // We only allow dragging posts when they're grouped by certain properties
    return [GroupByTypes.None, GroupByTypes.Section].includes(wishGroupBy.value)
  })
  const canIDragSections = computed(() => canIModerate.value && wishGroupBy.value === GroupByTypes.Section)
  const isReactable = computed<boolean>(() => surfaceVuexStore?.getters.isReactable ?? false)
  const isCommentable = computed<boolean>(() => surfaceVuexStore?.getters.isCommentable)
  const isRemakeable = computed<boolean>(() => surfaceVuexStore?.getters.isRemakeable)
  const requireApprovalForPosts = computed<boolean>(() => surfaceVuexStore?.getters.requireApproval)
  const visitorsCanModerate = computed<boolean>(
    () => surfaceVuexStore?.getters['wallAccessSettings/visitorsCanModerate'],
  )

  return {
    // getters
    canIModerate,
    isPostable,
    canIWrite,
    canIDragPosts,
    canIDragSections,
    isReactable,
    isCommentable,
    isRemakeable,
    requireApprovalForPosts,
    visitorsCanModerate,
  }
})
